import React from "react";
import { useState, useEffect } from "react";
import { Loader } from "../Loader";
import { api } from "../../api/client";
import { GENDER_BG_COLORS } from "../../pages/AdminDashboard";

const TabAllSchedules = () => {
  const [allSchedules, setAllSchedules] = useState([]);
  const [scheduleLoading, setScheduleLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [maxSchedulesPerPage, setMaxSchedulesPerPage] = useState(15);
  const [selectedDay, setSelectedDay] = useState("Show All");
  const [pageOn, setPageOn] = useState(1);
  const [pageOff, setPageOff] = useState(1);
  const [allSchedulesCache, setAllSchedulesCache] = useState([]);
  const [isCacheLoaded, setIsCacheLoaded] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredSchedules, setFilteredSchedules] = useState([]);

  const fetchAllSchedulesCache = async () => {
    setScheduleLoading(true);
    const r = await api(`/admin/all-schedules?page=1&limit=10000`);
    setAllSchedulesCache(r.schedules);
    setFilteredSchedules(r.schedules);
    setIsCacheLoaded(true);
    setScheduleLoading(false);
  };

  useEffect(() => {
    if (!isCacheLoaded) {
      fetchAllSchedulesCache();
    }
  }, []);

  const getDayOnSchedules = () => {
    if (selectedDay === "Show All") return [];
    return allSchedulesCache.filter((u) => {
      const daySchedule = u.schedule.find((s) => s.day === selectedDay);
      return daySchedule && !daySchedule.off;
    });
  };

  const getDayOffSchedules = () => {
    if (selectedDay === "Show All") return [];
    return allSchedulesCache.filter((u) => {
      const daySchedule = u.schedule.find((s) => s.day === selectedDay);
      return !daySchedule || daySchedule.off;
    });
  };

  const paginateData = (data, currentPage, perPage) => {
    const start = (currentPage - 1) * perPage;
    const end = start + perPage;
    return data.slice(start, end);
  };

  const getTotalPages = (data, perPage) => {
    return Math.ceil(data.length / perPage);
  };

  const getShowAllSchedules = () => {
    return paginateData(filteredSchedules, page, maxSchedulesPerPage);
  };

  const getShowAllTotalPages = () => {
    return getTotalPages(filteredSchedules, maxSchedulesPerPage);
  };

  return (
    <div className="card all-schedules-tab">
      <h3>All Passenger Schedules</h3>

      {scheduleLoading ? (
        <Loader />
      ) : (
        <>
          {selectedDay === "Show All" && <div style={{ marginBottom: "1rem" }}>
            <input
              type="text"
              placeholder="Search by name..."
              value={searchTerm}
              onChange={(e) => {
                const term = e.target.value.toLowerCase();
                setSearchTerm(term);
                setPage(1);
                if (term.trim() === "") {
                  setFilteredSchedules(allSchedulesCache);
                } else {
                  const filtered = allSchedulesCache.filter((u) =>
                    u.name.toLowerCase().includes(term)
                  );
                  setFilteredSchedules(filtered);
                }
              }}
              style={{
                width: "100%",
                maxWidth: "400px",
                padding: "0.5rem",
                fontSize: "0.875rem",
                border: "1px solid #d1d5db",
                borderRadius: "4px",
              }}
            />
          </div>}

          <div className="day-filter-container">
            <label htmlFor="day-filter">Filter by Day:</label>
            <select
              id="day-filter"
              className="tms-select"
              value={selectedDay}
              onChange={(e) => {
                setSelectedDay(e.target.value);
                setPageOn(1);
                setPageOff(1);
              }}
            >
              <option value="Show All">All Days</option>
              <option value="Mon">Mon</option>
              <option value="Tue">Tue</option>
              <option value="Wed">Wed</option>
              <option value="Thu">Thu</option>
              <option value="Fri">Fri</option>
              <option value="Sat">Sat</option>
            </select>
            <select
              value={maxSchedulesPerPage}
              className="tms-select"
              onChange={(e) => {
                const newLimit = parseInt(e.target.value);
                setMaxSchedulesPerPage(newLimit);
                setPage(1);
                setPageOn(1);
                setPageOff(1);
              }}
            >
              {
                <option value={allSchedulesCache.length}>All Schedules</option>
              }
              {[15, 30, 45, 60, 75, 90, 100].map((num) => (
                <option key={num} value={num}>
                  {num} per page
                </option>
              ))}
            </select>
          </div>

          {selectedDay === "Show All" ? (
            <>
              <div className="pagination-controls">
                <button
                  className="btn"
                  disabled={page === 1}
                  onClick={() => setPage(page - 1)}
                >
                  Prev
                </button>
                <span>
                  Page {page} of {getShowAllTotalPages() || 1}
                </span>
                <button
                  className="btn"
                  disabled={page >= getShowAllTotalPages()}
                  onClick={() => setPage(page + 1)}
                >
                  Next
                </button>
              </div>

              <div className="scroll-x">
                <table className="table table-list-big">
                  <thead>
                    <tr>
                      <th>SR #</th>
                      <th>Name</th>
                      <th>Stop</th>
                      <th>Mon</th>
                      <th>Tue</th>
                      <th>Wed</th>
                      <th>Thu</th>
                      <th>Fri</th>
                      <th>Sat</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getShowAllSchedules().length === 0 && (
                      <tr>
                        <td colSpan={8}>No schedules found</td>
                      </tr>
                    )}
                    {getShowAllSchedules().map((u, idx) => (
                      <tr key={u._id}>
                        <td>{(page - 1) * maxSchedulesPerPage + idx + 1}</td>
                        <td
                          style={{
                            backgroundColor:
                              GENDER_BG_COLORS[u.gender] || "transparent",
                          }}
                        >
                          {u.name}
                        </td>
                        <td>{u.stop?.name || u.stop || "-"}</td>
                        {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map(
                          (day) => {
                            const d = u.schedule.find((x) => x.day === day);
                            if (d?.off) {
                              return (
                                <td key={day} className={`${d?.temporaryChange ? "temporary-status" : ""}`}>
                                  OFF
                                  {d?.temporaryChange && (
                                    <div
                                      style={{
                                        fontSize: "0.75em",
                                        color: "#000000",
                                        marginTop: 4,
                                      }}
                                    >
                                      Temporary
                                    </div>
                                  )}
                                </td>
                              );
                            }
                            const morning = d?.morning || "";
                            const evening = d?.evening || "";
                            const display =
                              morning && evening
                                ? `${morning} - ${evening}`
                                : morning || evening || "-";
                            return (
                              <td key={day} className={`${d?.temporaryChange ? "temporary-status" : ""}`}>
                                {display}
                                {d?.temporaryChange && (
                                  <div
                                    style={{
                                      fontSize: "0.75em",
                                      color: "#000000",
                                      marginTop: 4,
                                    }}
                                  >
                                    Temporary
                                  </div>
                                )}
                              </td>
                            );
                          }
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="pagination-controls bottom">
                <button
                  className="btn"
                  disabled={page === 1}
                  onClick={() => setPage(page - 1)}
                >
                  Prev
                </button>
                <span>
                  Page {page} of {getShowAllTotalPages() || 1}
                </span>
                <button
                  className="btn"
                  disabled={page >= getShowAllTotalPages()}
                  onClick={() => setPage(page + 1)}
                >
                  Next
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="day-split-view">
                <div className="day-table-section on-section">
                  <h4>
                    Passengers with {selectedDay} ON (
                    {getDayOnSchedules().length})
                  </h4>
                  <div className="pagination-controls">
                    <button
                      className="btn"
                      disabled={pageOn === 1}
                      onClick={() => setPageOn(pageOn - 1)}
                    >
                      Prev
                    </button>
                    <span>
                      Page {pageOn} of{" "}
                      {getTotalPages(
                        getDayOnSchedules(),
                        maxSchedulesPerPage
                      ) || 1}
                    </span>
                    <button
                      className="btn"
                      disabled={
                        pageOn >=
                        getTotalPages(getDayOnSchedules(), maxSchedulesPerPage)
                      }
                      onClick={() => setPageOn(pageOn + 1)}
                    >
                      Next
                    </button>
                  </div>
                  <div className="scroll-x">
                    <table className="table table-list-big">
                      <thead>
                        <tr>
                          <th>SR #</th>
                          <th>Name</th>
                          <th>Stop</th>
                          <th>{selectedDay} Timing</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginateData(
                          getDayOnSchedules(),
                          pageOn,
                          maxSchedulesPerPage
                        ).length === 0 && (
                          <tr>
                            <td colSpan={4}>
                              No passengers with {selectedDay} ON
                            </td>
                          </tr>
                        )}
                        {paginateData(
                          getDayOnSchedules(),
                          pageOn,
                          maxSchedulesPerPage
                        ).map((u, idx) => {
                          const daySchedule = u.schedule.find(
                            (s) => s.day === selectedDay
                          );
                          const morning = daySchedule?.morning || "";
                          const evening = daySchedule?.evening || "";
                          const display =
                            morning && evening
                              ? `${morning} - ${evening}`
                              : morning || evening || "-";
                          return (
                            <tr key={u._id}>
                              <td>
                                {(pageOn - 1) * maxSchedulesPerPage + idx + 1}
                              </td>
                              <td
                                style={{
                                  backgroundColor:
                                    GENDER_BG_COLORS[u.gender] || "transparent",
                                }}
                              >
                                {u.name}
                              </td>
                              <td>{u.stop?.name || u.stop || "-"}</td>
                              <td className={`${daySchedule?.temporaryChange ? "temporary-status" : ""}`}>
                                {display}
                                {daySchedule?.temporaryChange && (
                                  <div
                                    style={{
                                      fontSize: "0.75em",
                                      color: "#000000",
                                      marginTop: 4,
                                    }}
                                  >
                                    Temporary
                                  </div>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="day-table-section off-section">
                  <h4>
                    Passengers with {selectedDay} OFF (
                    {getDayOffSchedules().length})
                  </h4>
                  <div className="pagination-controls">
                    <button
                      className="btn"
                      disabled={pageOff === 1}
                      onClick={() => setPageOff(pageOff - 1)}
                    >
                      Prev
                    </button>
                    <span>
                      Page {pageOff} of{" "}
                      {getTotalPages(
                        getDayOffSchedules(),
                        maxSchedulesPerPage
                      ) || 1}
                    </span>
                    <button
                      className="btn"
                      disabled={
                        pageOff >=
                        getTotalPages(getDayOffSchedules(), maxSchedulesPerPage)
                      }
                      onClick={() => setPageOff(pageOff + 1)}
                    >
                      Next
                    </button>
                  </div>
                  <div className="scroll-x">
                    <table className="table table-list-big">
                      <thead>
                        <tr>
                          <th>SR #</th>
                          <th>Name</th>
                          <th>Stop</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginateData(
                          getDayOffSchedules(),
                          pageOff,
                          maxSchedulesPerPage
                        ).length === 0 && (
                          <tr>
                            <td colSpan={4}>
                              No passengers with {selectedDay} OFF
                            </td>
                          </tr>
                        )}
                        {paginateData(
                          getDayOffSchedules(),
                          pageOff,
                          maxSchedulesPerPage
                        ).map((u, idx) => {
                          const daySchedule = u.schedule.find(
                            (s) => s.day === selectedDay
                          );
                          return (
                            <tr key={u._id}>
                              <td>
                                {(pageOff - 1) * maxSchedulesPerPage + idx + 1}
                              </td>
                              <td
                                style={{
                                  backgroundColor:
                                    GENDER_BG_COLORS[u.gender] || "transparent",
                                }}
                              >
                                {u.name}
                              </td>
                              <td>{u.stop?.name || u.stop || "-"}</td>
                              <td className={`${daySchedule?.temporaryChange ? "temporary-status" : ""}`}>
                                OFF
                                {daySchedule?.temporaryChange && (
                                  <div
                                    style={{
                                      fontSize: "0.75em",
                                      color: "#000000",
                                      marginTop: 4,
                                    }}
                                  >
                                    Temporary
                                  </div>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default TabAllSchedules;
